(ns hai.sharing.helper
  "Sharing/permissions helper functions. Some are temporary and have accumulated as the functionality has been rolled out."
  (:require
   [hai.ui.rf-sugar :refer [defevent-fx defsub]]
   [hai.entity.helpers :as entity]))

;; Entity helper fns

(defn can-edit?
  [entity]
  (or (:entity/new? entity)
      (some #{:permission.type/admin
              :permission.type/update}
            (:user.entity/permissions entity))))

(defn can-view?
  [entity]
  (some #{:permission.type/admin
          :permission.type/read}
        (:user.entity/permissions entity)))

(defn can-delete?
  [entity]
  (some #{:permission.type/admin
          :permission.type/delete}
        (:user.entity/permissions entity)))

(defn- db->routed-uuid
  [db]
  (get-in db [:routing/current-route :path-params :uuid]))

;; TODO Temporary
;; Evgheni and Donavan: AAAAAAAAHHHHHHHHHH!!!!
(defn ->uuid
  [entity]
  (or
   ;; Used for current prompt share page
   (:uuid entity)
   (entity/->uuid entity)))

;; TODO Temporary
(defn ->type
  [entity]
  (or (or
       ;; Table
       (and (:ai-prompt/uuid entity)
            "ai-prompts")
       (and (:ai-model-config/uuid entity)
            "ai-model-configs")
       ;; Sharing page
       (and (:title entity)
            (:content entity)
            "ai-prompts"))
      ;; Table
      (and (:user/uuid entity)
           "users")
      (throw (ex-info "->type conversion failed" {:entity entity}))))

;; TODO Temporary
(defn ->singular-type
  [entity]
  (or
   ;; Table
   (and (:ai-prompt/uuid entity)
        "ai-prompt")
   (and (:ai-model-config/uuid entity)
        "ai-model-config")
   (and (:connection/uuid entity)
        "connection")
   (and (:mini-app/uuid entity)
        "mini-app")
   (and (:group/uuid entity)
        "group")
   ;; Sharing page
   (and (:title entity)
        (:content entity)
        "ai-prompt")
   (throw (ex-info "->singular-type conversion failed" {:entity entity}))))

(defn entity-route
  ([type {:keys [uuid]}]
   (str "/share/" type "/" uuid))
  ([entity]
   (str "/share/" (->singular-type entity) "/" (->uuid entity))))

(def entity->api-route (comp entity-route :uuid))

(defn entity-shares-route
  [entity]
  (str "/assistant/v0/" (->type entity) "/" (->uuid entity) "/shares"))

(defevent-fx :entity.shares/read
  [_ {:keys [entity]}]
  {:fetch {:url (entity-shares-route entity)
           :store-in [:shares]}})

(defevent-fx :entity.shares/publish
  [_ {:keys [entity on-success-fx]}]
  {:fetch (merge
           {:url (entity-route entity)
            :method :put
            :body {:scope "published"
                   :levels ["permission.type/read"]}}
           (when on-success-fx
             {:on-success-fx on-success-fx}))})

(defevent-fx :entity.shares/unpublish
  [_ {:keys [entity on-success-fx]}]
  {:fetch (merge
           {:url (entity-route entity)
            :method :delete
            :body {:scope "published"
                   :levels ["permission.type/read"]}}
           (when on-success-fx
             {:on-success-fx on-success-fx}))})

(defevent-fx :entity.shares/delete
  [_
   ;; TODO hardcoded type
   {:keys [user entity type permission on-success]
    :as args
    :or {on-success []}}]
  {:fetch {:url (entity-route entity)
           :body {:owners [["user/uuid" (str (:user/uuid user))]]
                  ;; TODO sort out levels coercion with Malli
                  :levels [(str (namespace permission) "/" (name permission))]}
           :method :delete
           :on-success-fx on-success}})

(defsub :routed-prompt-shares
  [db]
  (get-in db [:shares]))
